import React from 'react'
import {withStyles} from 'material-ui/styles/index'
import Paper from 'material-ui/Paper'
import List from 'material-ui/List'
import moment from 'moment'
import Table, {TablePagination, TableFooter, TableRow} from 'material-ui/Table'
import {activity as styles} from '../styles'
import {activity as text} from '../text'
import ErrorMessage from '../../../common/components/ErrorMessage'
import HeaderProgress from '../../../common/components/HeaderProgress'

class Activity extends React.Component {

  state = {
    page: 0,
    rowsPerPage: 10,
  }

  handleChangePage = (event, page) => {
    this.setState({page})
  }

  handleChangeRowsPerPage = event => {
    this.setState({rowsPerPage: event.target.value})
  }

  render() {
    const {classes, isLoading, error, notifications} = this.props
    const {rowsPerPage, page} = this.state

    if (error !== '') {
      return <ErrorMessage error={error}/>
    }

    return (
      <div>
        <HeaderProgress show={isLoading}/>
        {!isLoading && notifications.size === 0 && <NoActivities classes={classes}/>}
        <List style={{marginTop: 35, minHeight: 520}}>
          {notifications.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((notification, key) =>
            <Paper className={classes.activityContainer} key={key}>
              {this.parseMessage(notification.Message)}
              <p className={classes.activityDate}>{moment(notification.CreationDate).format('DD MMMM YYYY')}</p>
            </Paper>,
          )}
        </List>
        <Table>
          <TableFooter>
            <TableRow>
              <TablePagination
                count={notifications.size}
                onChangePage={this.handleChangePage}
                page={page}
                rowsPerPage={rowsPerPage}
                onChangeRowsPerPage={this.handleChangeRowsPerPage}
              />
            </TableRow>
          </TableFooter>
        </Table>
      </div>
    )
  }

  parseMessage = (message) => { // This function is for making keywords black colored
    let dividedWords = message.split('\'')

    if (dividedWords.length !== 3) {
      return (
        <p className={this.props.classes.activityContent}>
          {message}
        </p>
      )
    }

    return (
      <p className={this.props.classes.activityContent}>
        {dividedWords[0]}
        <em className={this.props.classes.boldText}>{dividedWords[1]}</em>
        {dividedWords[2]}
      </p>
    )
  }

  static propTypes = {}
}

class NoActivities extends React.Component {
  render() {
    const noActivitiesImagePath = '/assets/noActivities.png'

    return (
      <div className={this.props.classes.noActivitiesContainer}>
        <img src={noActivitiesImagePath} className={this.props.classes.noActivitiesImage} alt={'no activities'}/>
        <p className={this.props.classes.noActivitiesTitle}>{text.noActivitiesTitle}</p>
        <p className={this.props.classes.noActivitiesSubtitle}>{text.noActivitiesSubtitle}</p>
      </div>
    )
  }
}

export default withStyles(styles, {withTheme: true})(Activity)



// WEBPACK FOOTER //
// ./src/sections/activity/components/activity.js